export function FullscreenEnterIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" fill="#fff" role="img">
      <path d="M0 0h5v2H2v3H0V0zm9 0h5v5h-2V2H9V0zm3 9h2v5H9v-2h3V9zm-7 3v2H0V9h2v3h3z" />
    </svg>
  );
}
